import { render } from "./order-status-description.vue?vue&type=template&id=74c2fa58&scoped=true"
import script from "./order-status-description.vue?vue&type=script&lang=js"
export * from "./order-status-description.vue?vue&type=script&lang=js"

import "./order-status-description.vue?vue&type=style&index=0&id=74c2fa58&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c2fa58"]])

export default __exports__